// La sala riunioni della landing: quattro idee da scegliere con le linguette, e in ognuna i pop
// che ne discutono, una nuvoletta dopo l'altra in un ciclo di 18 secondi (tela, «Landing page»).
// Cambiare scena rimonta la conversazione, così l'animazione riparte dall'inizio.
// Le scene girano da sole a fine ciclo (richiesta dell'utente del 2026-11-01: «4 5 chat
// diverse»); una linguetta scelta a mano ferma il giro, e con «riduci movimento» resta ferma.
import { useEffect, useState } from 'react';
import { SCENES, pop } from './landingData';

const CYCLE_MS = 18_000;

export function LandingScene() {
  const [current, setCurrent] = useState(SCENES[0].id);
  const [picked, setPicked] = useState(false);
  const scene = SCENES.find((s) => s.id === current) ?? SCENES[0];

  useEffect(() => {
    if (picked || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const timer = window.setTimeout(() => {
      const i = SCENES.findIndex((s) => s.id === current);
      setCurrent(SCENES[(i + 1) % SCENES.length].id);
    }, CYCLE_MS);
    return () => window.clearTimeout(timer);
  }, [current, picked]);
  return (
    <div id="sala" className="ld-stage">
      <div role="tablist" aria-label="Idee in discussione" className="ld-tabs">
        {SCENES.map((s) => (
          <button
            key={s.id}
            role="tab"
            aria-selected={s.id === current}
            className="ld-tab"
            onClick={() => {
              setPicked(true);
              setCurrent(s.id);
            }}
          >
            <img src={pop(s.icon)} alt="" width={26} height={26} />
            {s.label}
          </button>
        ))}
      </div>
      <div key={scene.id} className="ld-room">
        <div className="ld-room-bar">
          <span className="ld-light" data-tint="coral" />
          <span className="ld-light" data-tint="sun" />
          <span className="ld-light" data-tint="mint" />
          <span className="ld-room-title">Sala riunioni · {scene.title}</span>
          <span className="ld-live">dal vivo</span>
        </div>
        <div className="ld-chat">
          {scene.lines.map(([avatar, who, tint, text], i) => (
            <div
              key={i}
              className="ld-line"
              data-tint={tint}
              style={{
                flexDirection: i % 2 ? 'row-reverse' : 'row',
                animationName: `ld-b${i + 1}`,
              }}
            >
              <img
                src={pop(avatar)}
                alt=""
                className="ld-bob"
                style={{ animationDelay: `${i * 0.4}s` }}
              />
              <div className="ld-bubble">
                <div className="ld-who">{who}</div>
                <div>{text}</div>
              </div>
            </div>
          ))}
          <div className="ld-done">
            <svg
              aria-hidden="true"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12l5 5L20 7" />
            </svg>
            {scene.done}
          </div>
          <div className="ld-typing">
            <span />
            <span />
            <span />
            il team sta pensando…
          </div>
        </div>
      </div>
      <div className="ld-badge">6 pop · 1 idea</div>
    </div>
  );
}
